import { getAHRISystemToolCategory } from "@crescentParts/Services/AHRISystemToolService";
import { AHRISystemToolCategoryModel } from "@crescentParts/Widgets/CustomApiModels";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

type Parameter = {
    brand: string;
} & HasOnSuccess<AHRISystemToolCategoryModel>;

type Props = {
    apiResult: AHRISystemToolCategoryModel;
};

type HandlerType = ApiHandlerDiscreteParameter<Parameter, Props, AHRISystemToolCategoryModel>

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await getAHRISystemToolCategory(props.parameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [SendDataToApi, ExecuteOnSuccessCallback];

const getAHRISystemToolConfigCategory = createHandlerChainRunner(chain, "getAHRISystemToolConfigCategory");
export default getAHRISystemToolConfigCategory;
